import React from 'react';
import { observer } from 'mobx-react-lite';
import { getAmountWithCurrency, useTranslation, useUserInfoStore } from '@pascal/pascal-core';
import { winningStore } from '../../store/winningStore';

export const FooterSection = observer(() => {
  const { lastWinAmount } = winningStore;
  const { balance } = useUserInfoStore();
  const t = useTranslation();

  return (
    <div className='tb-g-b-btn-b'>
      <div className='tb-g-b-btn-b-cl'>
        <p className='tb-g-b-btn-b-cl-txt'>
          {t('BALANCE')}: {getAmountWithCurrency({ amount: balance })}
        </p>
      </div>
      <div className='tb-g-b-btn-b-cl'>
        <p className='tb-g-b-btn-b-cl-txt'>
          {t('LAST_WIN')}: {!!lastWinAmount && getAmountWithCurrency({ amount: lastWinAmount })}
        </p>
      </div>
    </div>
  );
});
